import React from "react";
import ReactDOM from "react-dom/client";
import 'bootstrap/dist/css/bootstrap.css';

import App from "./App";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <a href="https://github.com/Zizo95/React-weather-app" target="_blank" rel="noopener noreferrer">Open source by</a> Zizo Brown
  </React.StrictMode>
);


